export default __webpack_public_path__ + "static/Do-Align-buttons-bottom-right-86ccc50ea89a9a832cf1d7151e14c920.png";